export default __webpack_public_path__ + "static/media/landing-page-head-img-6.8dcaee12.jpg";